import React from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  RadioCircle,
  Info,
  MemberName,
  DetailRow,
  MemberIdLabel,
  ConnectedApps,
  ConnectedAppsLabel,
  ConnectedAppsValue,
  NoneText,
} from "./styles";

export type MemberInfo = {
  memberId: string;
  memberName: string;
  enabled: boolean;
  connectedApps: string[];
};

type Props = {
  member: MemberInfo;
  isSelected: boolean;
  isSelectable: boolean;
  onSelect?: (memberId: string) => void;
};

const MemberCard: React.FC<Props> = ({
  member,
  isSelected,
  isSelectable,
  onSelect,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (isSelectable && onSelect) {
      onSelect(member.memberId);
    }
  };

  return (
    <Card
      isSelected={isSelected}
      isSelectable={isSelectable}
      onClick={handleClick}
      role={isSelectable ? "radio" : undefined}
      aria-checked={isSelectable ? isSelected : undefined}
      tabIndex={isSelectable ? 0 : undefined}
      onKeyDown={e => {
        if (isSelectable && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {isSelectable && <RadioCircle isSelected={isSelected} />}
      <Info>
        <MemberName>{member.memberName}</MemberName>
        <DetailRow>
          <MemberIdLabel>{t("memberPage:memberId")}:</MemberIdLabel>{" "}
          {member.memberId}
        </DetailRow>
        {member.connectedApps.length > 0 ? (
          <ConnectedApps>
            <ConnectedAppsLabel>
              {t("memberPage:connectedApps")}:
            </ConnectedAppsLabel>{" "}
            <ConnectedAppsValue>
              {member.connectedApps.join(", ")}
            </ConnectedAppsValue>
          </ConnectedApps>
        ) : (
          <NoneText>
            <ConnectedAppsLabel>
              {t("memberPage:connectedApps")}:
            </ConnectedAppsLabel>{" "}
            {t("memberPage:none")}
          </NoneText>
        )}
      </Info>
    </Card>
  );
};

export default MemberCard;
